import { CompareSalesDataTableFooter } from "@/components/DataTable/compareSalesDataTableFooter";
import { GridPagination } from "@mui/x-data-grid";

export default function CompareSalesFooter(props) {
  return (
    <>
      <CompareSalesDataTableFooter {...props}></CompareSalesDataTableFooter>
      <GridPagination></GridPagination>
    </>
  );
}
